module.exports = __webpack_public_path__ + "static/media/sophia_lee.e6b99391.png";